module.exports = __webpack_public_path__ + "assets/boxicons.deea39cb9dc8b17f9d640014ca2f87af.woff";